import {
  DisabilitySelfIdentification,
  GenderSelfIdentification,
  PreferredUsWorkLocation,
  ProtectedVeteranSelfIdentification,
  RaceSelfIdentification,
} from '../services/openapi/model/models';
import { DisabilitySelfIdentificationCA } from '../services/openapi/model/disabilitySelfIdentificationCA';
import { IndigenousIdSelfIdentification } from '../services/openapi/model/indigenousIdSelfIdentification';
import { RaceSelfIdentificationCA } from '../services/openapi/model/raceSelfIdentificationCA';
export interface LocalizedCode {
  code: string;
  localizedLabel: string;
}

export const PCL_OPERATING_COUNTRIES: Record<string, string> = {
  AU: 'Australia',
  CA: 'Canada',
  US: 'United States',
};

export const SECTORS: LocalizedCode[] = [
  {
    code: 'BuildingsAndCivilCA',
    localizedLabel: $localize`@@SECTORS.BuildingsAndCivilCA:Canadian Buildings and Civil`,
  },
  { code: 'BuildingsUS', localizedLabel: $localize`:@@SECTORS.BuildingsUS:US Buildings` },
  { code: 'CivilUS', localizedLabel: $localize`:@@SECTORS.CivilUS:US Civil` },
  { code: 'IndustrialCA', localizedLabel: $localize`:@@SECTORS.IndustrialCA:Canadian Industrial` },
  { code: 'IndustrialUS', localizedLabel: $localize`:@@SECTORS.IndustrialUS:US Industrial` },
];

export const TRADE_SEARCH_HINTS: string[] = [
  'Boiler maker',
  'Brick layer',
  'Carpenter',
  'Electrician',
  'Elevator mechanic',
  'Fencer',
  'Glazier',
  'HVAC Technician',
  'Heavy equipment operator',
  'Insulator',
  'Ironworker',
  'Laborer',
  'Landscaper',
  'Mason',
  'Millwright',
  'Painter',
  'Pipefitter',
  'Plasterer',
  'Plumber',
  'Roofer',
  'Welder',
];

export const COUNTRIES: Record<string, string> = {
  CA: 'Canada',
  US: 'United States',
  AF: 'Afghanistan',
  AX: 'Åland Islands',
  AL: 'Albania',
  DZ: 'Algeria',
  AS: 'American Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarctica',
  AG: 'Antigua and Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivia',
  BQ: 'Bonaire, Sint Eustatius and Saba',
  BA: 'Bosnia and Herzegovina',
  BW: 'Botswana',
  BV: 'Bouvet Island',
  BR: 'Brazil',
  IO: 'British Indian Ocean Territory',
  BN: 'Brunei Darussalam',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  CV: 'Cabo Verde',
  KH: 'Cambodia',
  CM: 'Cameroon',
  KY: 'Cayman Islands',
  CF: 'Central African Republic',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CX: 'Christmas Island',
  CC: 'Cocos (Keeling) Islands',
  CO: 'Colombia',
  KM: 'Comoros',
  CD: 'Congo (Democratic Republic)',
  CG: 'Congo (Republic)',
  CK: 'Cook Islands',
  CR: 'Costa Rica',
  CI: "Côte d'Ivoire",
  HR: 'Croatia',
  CU: 'Cuba',
  CW: 'Curaçao',
  CY: 'Cyprus',
  CZ: 'Czechia',
  DK: 'Denmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  GQ: 'Equatorial Guinea',
  ER: 'Eritrea',
  EE: 'Estonia',
  SZ: 'Eswatini',
  ET: 'Ethiopia',
  FK: 'Falkland Islands [Malvinas]',
  FO: 'Faroe Islands',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GF: 'French Guiana',
  PF: 'French Polynesia',
  TF: 'French Southern Territories',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Greece',
  GL: 'Greenland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HM: 'Heard Island and McDonald Islands',
  VA: 'Vatican City',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran',
  IQ: 'Iraq',
  IE: 'Ireland',
  IM: 'Isle of Man',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  JE: 'Jersey',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KP: 'North Korea',
  KR: 'South Korea',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: 'Laos',
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libya',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MO: 'Macao',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshall Islands',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Mexico',
  FM: 'Micronesia',
  MD: 'Moldova',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Morocco',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Netherlands',
  NC: 'New Caledonia',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolk Island',
  MK: 'Macedonia',
  MP: 'Northern Mariana Islands',
  NO: 'Norway',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palestinian Territory',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines',
  PN: 'Pitcairn',
  PL: 'Poland',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  RE: 'Reunion',
  RO: 'Romania',
  RU: 'Russian Federation',
  RW: 'Rwanda',
  BL: 'Saint Barthélemy',
  SH: 'Saint Helena, Ascension and Tristan da Cunha',
  KN: 'Saint Kitts and Nevis',
  LC: 'Saint Lucia',
  MF: 'Saint Martin (French part)',
  PM: 'Saint Pierre and Miquelon',
  VC: 'Saint Vincent and the Grenadines',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Sao Tome and Principe',
  SA: 'Saudi Arabia',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SX: 'Sint Maarten (Dutch part)',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  SO: 'Somalia',
  ZA: 'South Africa',
  GS: 'South Georgia and the South Sandwich Islands',
  SS: 'South Sudan',
  ES: 'Spain',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Suriname',
  SJ: 'Svalbard and Jan Mayen',
  SE: 'Sweden',
  CH: 'Switzerland',
  SY: 'Syrian Arab Republic',
  TW: 'Taiwan (Province of China)',
  TJ: 'Tajikistan',
  TZ: 'Tanzania',
  TH: 'Thailand',
  TL: 'Timor-Leste',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad and Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TM: 'Turkmenistan',
  TC: 'Turks and Caicos Islands',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates',
  GB: 'United Kingdom',
  UM: 'United States Minor Outlying Islands',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela',
  VN: 'Vietnam',
  VG: 'Virgin Islands (British)',
  VI: 'Virgin Islands (U.S.)',
  WF: 'Wallis and Futuna',
  EH: 'Western Sahara',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
};
export const COUNTRIES_MAP = new Map<string, string>(Object.entries(COUNTRIES));

export const COUNTRY_SUBDIVISIONS: Record<string, string> = {
  CA_AB: 'Alberta',
  CA_BC: 'British Columbia',
  CA_MB: 'Manitoba',
  CA_NB: 'New Brunswick',
  CA_NL: 'Newfoundland and Labrador',
  CA_NS: 'Nova Scotia',
  CA_NT: 'Northwest Territories',
  CA_NU: 'Nunavut',
  CA_ON: 'Ontario',
  CA_PE: 'Prince Edward Island',
  CA_QC: 'Quebec',
  CA_SK: 'Saskatchewan',
  CA_YT: 'Yukon',
  US_AL: 'Alabama',
  US_AK: 'Alaska',
  US_AZ: 'Arizona',
  US_AR: 'Arkansas',
  US_CA: 'California',
  US_CO: 'Colorado',
  US_CT: 'Connecticut',
  US_DE: 'Delaware',
  US_FL: 'Florida',
  US_GA: 'Georgia',
  US_HI: 'Hawaii',
  US_ID: 'Idaho',
  US_IL: 'Illinois',
  US_IN: 'Indiana',
  US_IA: 'Iowa',
  US_KS: 'Kansas',
  US_KY: 'Kentucky',
  US_LA: 'Louisiana',
  US_ME: 'Maine',
  US_MD: 'Maryland',
  US_MA: 'Massachusetts',
  US_MI: 'Michigan',
  US_MN: 'Minnesota',
  US_MS: 'Mississippi',
  US_MO: 'Missouri',
  US_MT: 'Montana',
  US_NE: 'Nebraska',
  US_NV: 'Nevada',
  US_NH: 'New Hampshire',
  US_NJ: 'New Jersey',
  US_NM: 'New Mexico',
  US_NY: 'New York',
  US_NC: 'North Carolina',
  US_ND: 'North Dakota',
  US_OH: 'Ohio',
  US_OK: 'Oklahoma',
  US_OR: 'Oregon',
  US_PA: 'Pennsylvania',
  US_RI: 'Rhode Island',
  US_SC: 'South Carolina',
  US_SD: 'South Dakota',
  US_TN: 'Tennessee',
  US_TX: 'Texas',
  US_UT: 'Utah',
  US_VT: 'Vermont',
  US_VA: 'Virginia',
  US_WA: 'Washington',
  US_WV: 'West Virginia',
  US_WI: 'Wisconsin',
  US_WY: 'Wyoming',
};
export const COUNTRY_SUBDIVISIONS_MAP = new Map<string, string>(Object.entries(COUNTRY_SUBDIVISIONS));

export const MONTH_YEAR_FORMAT = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MMM, YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export const PHONE_TYPE_LOOKUP_CODES: Record<string, string> = {
  Mobile: 'Mobile',
  LandLine: 'Land line',
};

export const EMERGENCY_CONTACT_RELATION_TYPES = [
  'Spouse',
  'Domestic Partner',
  'Parent',
  'Child',
  'Sibling',
  'Relative',
  'Friend',
] as const;

export type EmergencyContactRelationType = (typeof EMERGENCY_CONTACT_RELATION_TYPES)[number];

export const US_WORK_LOCATIONS_MAP: ReadonlyMap<PreferredUsWorkLocation, string> = new Map([
  [PreferredUsWorkLocation.PacificCoastal, 'Pacific Coastal (CA, OR, WA, HI)'],
  [PreferredUsWorkLocation.GulfCoast, 'Gulf Coast (LA, MS, AL, FL)'],
  [PreferredUsWorkLocation.Southern, 'Southern (VA, WV, KY, DE, MD, NC, SC, TN, AR, LA, FL, GA, AL, MS)'],
  [PreferredUsWorkLocation.MidAtlantic, 'Mid-Atlantic (NY, NJ, PA)'],
  [PreferredUsWorkLocation.NewEngland, 'New England (ME, RI, VT, CT, NH, MA)'],
  [PreferredUsWorkLocation.MidWest, 'Mid-West (MI, ND, SD, IA, MN, KS, NE, OH, IN, IL, WI, MO)'],
  [PreferredUsWorkLocation.Texas, 'Texas (TX)'],
  [PreferredUsWorkLocation.RockyMountains, 'Rocky Mountains (MT, ID, CO, UT, WY, NV)'],
  [PreferredUsWorkLocation.NorthPacific, 'North-Pacific (AK)'],
  [PreferredUsWorkLocation.SouthWest, 'South-West (AZ, NM, OK)'],
]);

export interface CaWorkLocationDistrict {
  id: string;
  name: string;
}

export interface CaWorkLocationCity {
  city: string;
  districts: CaWorkLocationDistrict[];
}

export const CA_WORK_LOCATIONS: CaWorkLocationCity[] = [
  {
    city: 'Edmonton',
    districts: [
      { id: '05_1', name: 'Grand Sierra Construction Inc.' },
      { id: '26', name: 'Melloy Industrial Services Inc.' },
      { id: '21', name: 'PCL Energy Inc.' },
      { id: '15', name: 'PCL Industrial Constructors Inc.' },
      { id: '05', name: 'PCL Builders Inc. - Edmonton' },
    ],
  },
  {
    city: 'Calgary',
    districts: [{ id: '04', name: 'PCL Builders Inc. - Calgary' }],
  },
  {
    city: 'Halifax',
    districts: [{ id: '09_1', name: 'Atlantic Canada Buildings and Civil' }],
  },
  {
    city: 'Kelowna',
    districts: [{ id: '22_1', name: 'PCL Constructors Westcoast Inc.' }],
  },
  {
    city: 'Montreal',
    districts: [{ id: '10-02410', name: 'Quebec Buildings and Civil' }],
  },
  {
    city: 'Ottawa',
    districts: [
      { id: '10', name: 'Ottawa Buildings and Civil' },
      { id: '32', name: 'Dalcon' },
    ],
  },
  {
    city: 'Regina',
    districts: [{ id: '06', name: 'PCL Builders Inc. – Regina' }],
  },
  {
    city: 'Saskatoon',
    districts: [{ id: '06_1', name: 'PCL Builders Inc. – Saskatoon' }],
  },
  {
    city: 'Sudbury',
    districts: [{ id: '09_2', name: 'Northern Ontario Buildings and Civil' }],
  },
  {
    city: 'Toronto',
    districts: [
      { id: '09', name: 'Toronto Buildings and Civil' },
      { id: '09_3', name: 'Toronto Solar' },
    ],
  },
  {
    city: 'Vancouver',
    districts: [{ id: '22', name: 'PCL Constructors Westcoast Inc.' }],
  },
  {
    city: 'Winnipeg',
    districts: [{ id: '08', name: 'Winnipeg Buildings and Civil' }],
  },
];

export const EXPERIENCE_LEVELS: LocalizedCode[] = [
  {
    code: 'EntryLevelApprenticeOrHelper',
    localizedLabel: $localize`:@@EXPERIENCE_LEVELS.EntryLevelApprenticeOrHelper:Entry-level apprentice/helper`,
  },
  {
    code: '1stYearApprenticeOrHelper',
    localizedLabel: $localize`:@@EXPERIENCE_LEVELS.1stYearApprenticeOrHelper:1st year apprentice/helper`,
  },
  {
    code: '2ndYearApprenticeOrHelper',
    localizedLabel: $localize`:@@EXPERIENCE_LEVELS.2ndYearApprenticeOrHelper:2nd year apprentice/helper`,
  },
  {
    code: '3rdYearApprenticeOrHelper',
    localizedLabel: $localize`:@@EXPERIENCE_LEVELS.3rdYearApprenticeOrHelper:3rd year apprentice/helper`,
  },
  {
    code: '4thYearApprenticeOrHelper',
    localizedLabel: $localize`:@@EXPERIENCE_LEVELS.4thYearApprenticeOrHelper:4th year apprentice/helper`,
  },
  { code: 'TopHelper', localizedLabel: $localize`:@@EXPERIENCE_LEVELS.TopHelper:Top Helper` },
  {
    code: 'NonCertifiedJourneyman',
    localizedLabel: $localize`:@@EXPERIENCE_LEVELS.NonCertifiedJourneyman:Non-Certified Journeyman`,
  },
  {
    code: 'CertifiedJourneyman',
    localizedLabel: $localize`:@@EXPERIENCE_LEVELS.CertifiedJourneyman:Certified Journeyman`,
  },
  {
    code: 'Journeyman',
    localizedLabel: $localize`:@@EXPERIENCE_LEVELS.Journeyman:Journeyman (More than 4 years of experience in craft)`,
  },
  { code: 'Foreman', localizedLabel: $localize`:@@EXPERIENCE_LEVELS.Foreman:Foreman` },
  { code: 'GeneralForeman', localizedLabel: $localize`:@@EXPERIENCE_LEVELS.GeneralForeman:General foreman` },
];
export const EXPERIENCE_LEVELS_MAP = new Map<string, string>(EXPERIENCE_LEVELS.map((x) => [x.code, x.localizedLabel]));

export const YEARS_OF_EXPERIENCE: LocalizedCode[] = [
  { code: 'None', localizedLabel: $localize`:@@YEARS_OF_EXPERIENCE.None:None` },
  { code: 'LessThan1', localizedLabel: $localize`:@@YEARS_OF_EXPERIENCE.LessThan1:Less than 1` },
  { code: 'Between1And2', localizedLabel: $localize`:@@YEARS_OF_EXPERIENCE.Between1And2:1 - 2` },
  { code: 'Between3And4', localizedLabel: $localize`:@@YEARS_OF_EXPERIENCE.Between3And4:3 - 4` },
  { code: 'Between5And6', localizedLabel: $localize`:@@YEARS_OF_EXPERIENCE.Between5And6:5 - 6` },
  { code: 'Between7And8', localizedLabel: $localize`:@@YEARS_OF_EXPERIENCE.Between7And8:7 - 8` },
  { code: 'Between9And10', localizedLabel: $localize`:@@YEARS_OF_EXPERIENCE.Between9And10:9 - 10` },
  { code: 'Between11And15', localizedLabel: $localize`:@@YEARS_OF_EXPERIENCE.Between11And15:11 - 15` },
  { code: 'MoreThan15', localizedLabel: $localize`:@@YEARS_OF_EXPERIENCE.MoreThan15:More than 15` },
];
export const YEARS_OF_EXPERIENCE_MAP = new Map<string, string>(
  YEARS_OF_EXPERIENCE.map((x) => [x.code, x.localizedLabel])
);

export type TradeType = LocalizedCode & {
  subCraftTypes?: LocalizedCode[];
};
export const TRADE_TYPES: TradeType[] = [
  { code: 'Boilermaker', localizedLabel: $localize`:@@TRADE_TYPES.Boilermaker:Boilermaker` },
  { code: 'Bricklayer', localizedLabel: $localize`:@@TRADE_TYPES.Bricklayer:Bricklayer` },
  {
    code: 'Carpenter',
    localizedLabel: $localize`:@@TRADE_TYPES.Carpenter:Carpenter`,
    subCraftTypes: [
      { code: 'DecksColumns', localizedLabel: $localize`:@@SUB_TRADE_TYPES.Carpenter.DecksColumns:Decks/columns` },
      { code: 'Flatwork', localizedLabel: $localize`:@@SUB_TRADE_TYPES.Carpenter.Flatwork:Flatwork` },
      {
        code: 'HeavyMetalForms',
        localizedLabel: $localize`:@@SUB_TRADE_TYPES.Carpenter.HeavyMetalForms:Heavy/Metal forms`,
      },
      { code: 'Scaffolding', localizedLabel: $localize`:@@SUB_TRADE_TYPES.Carpenter.Scaffolding:Scaffolding` },
    ],
  },
  { code: 'CementMason', localizedLabel: $localize`:@@TRADE_TYPES.CementMason:Cement Mason` },
  { code: 'Cladder', localizedLabel: $localize`:@@TRADE_TYPES.Cladder:Cladder` },
  {
    code: 'Concrete_BrickAndBlock',
    localizedLabel: $localize`:@@TRADE_TYPES.Concrete_BrickAndBlock:Concrete (Brick and block)`,
  },
  { code: 'Concrete_Finisher', localizedLabel: $localize`:@@TRADE_TYPES.Concrete_Finisher:Concrete (Finisher)` },
  {
    code: 'Concrete_PatchingAndSurfaceRepairs',
    localizedLabel: $localize`:@@TRADE_TYPES.Concrete_PatchingAndSurfaceRepairs:Concrete (Patching and surface repairs)`,
  },
  { code: 'Electrician', localizedLabel: $localize`:@@TRADE_TYPES.Electrician:Electrician` },
  { code: 'ElevatorConstructor', localizedLabel: $localize`:@@TRADE_TYPES.ElevatorConstructor:Elevator Constructor` },
  { code: 'Formsetter', localizedLabel: $localize`:@@TRADE_TYPES.Formsetter:Formsetter` },
  { code: 'GasFitter', localizedLabel: $localize`:@@TRADE_TYPES.GasFitter:Gas Fitter` },
  { code: 'Installer', localizedLabel: $localize`:@@TRADE_TYPES.Installer:Installer` },
  { code: 'Instrumentation', localizedLabel: $localize`:@@TRADE_TYPES.Instrumentation:Instrumentation` },
  { code: 'Insulation', localizedLabel: $localize`:@@TRADE_TYPES.Insulation:Insulation` },
  {
    code: 'IronWorker_ResteelAndRebar',
    localizedLabel: $localize`:@@TRADE_TYPES.IronWorker_ResteelAndRebar:Iron worker (Re-steel and re-bar)`,
  },
  {
    code: 'IronWorker_Structural',
    localizedLabel: $localize`:@@TRADE_TYPES.IronWorker_Structural:Iron worker (Structural)`,
  },
  { code: 'Laborer', localizedLabel: $localize`:@@TRADE_TYPES.Laborer:Laborer` },
  { code: 'MaterialsTechnician', localizedLabel: $localize`:@@TRADE_TYPES.MaterialsTechnician:Materials Technician` },
  {
    code: 'Mechanic_EquipmentDiesel',
    localizedLabel: $localize`:@@TRADE_TYPES.Mechanic_EquipmentDiesel:Mechanic (Equipment/diesel)`,
  },
  {
    code: 'Millwright_GasTurbine',
    localizedLabel: $localize`:@@TRADE_TYPES.Millwright_GasTurbine:Millwright (Gas turbine)`,
  },
  {
    code: 'Millwright_SteamTurbine',
    localizedLabel: $localize`:@@TRADE_TYPES.Millwright_SteamTurbine:Millwright (Precision)`,
  },
  {
    code: 'Millwright_Precision',
    localizedLabel: $localize`:@@TRADE_TYPES.Millwright_Precision:Millwright (Steam turbine)`,
  },
  {
    code: 'Operator',
    localizedLabel: $localize`:@@TRADE_TYPES.Operator:Operator`,
    subCraftTypes: [
      { code: 'Backhoe', localizedLabel: $localize`:@@SUB_TRADE_TYPES.Operator.Backhoe:Backhoe` },
      { code: 'Crane', localizedLabel: $localize`:@@SUB_TRADE_TYPES.Operator.Crane:Crane` },
      { code: 'DirtMover', localizedLabel: $localize`:@@SUB_TRADE_TYPES.Operator.DirtMover:Dirt Mover` },
      {
        code: 'Other',
        localizedLabel: $localize`:@@SUB_TRADE_TYPES.Operator.Other:Other (forklift, aerial lift, etc)`,
      },
      { code: 'WaterTruck', localizedLabel: $localize`:@@SUB_TRADE_TYPES.Operator.WaterTruck:Water Truck` },
    ],
  },
  { code: 'Other', localizedLabel: $localize`:@@TRADE_TYPES.Other:Other` },
  {
    code: 'Painter',
    localizedLabel: $localize`:@@TRADE_TYPES.Painter:Painter`,
    subCraftTypes: [
      { code: 'Sandblaster', localizedLabel: $localize`:@@SUB_TRADE_TYPES.Painter.Sandblaster:Sandblaster` },
    ],
  },
  { code: 'Piledriver', localizedLabel: $localize`:@@TRADE_TYPES.Piledriver:Piledriver` },
  { code: 'PipeFabricator', localizedLabel: $localize`:@@TRADE_TYPES.PipeFabricator:Pipe fabricator` },
  { code: 'Pipefitter', localizedLabel: $localize`:@@TRADE_TYPES.Pipefitter:Pipefitter` },
  { code: 'Plumber', localizedLabel: $localize`:@@TRADE_TYPES.Plumber:Plumber` },
  { code: 'Rigger', localizedLabel: $localize`:@@TRADE_TYPES.Rigger:Rigger` },
  { code: 'RodBuster', localizedLabel: $localize`:@@TRADE_TYPES.RodBuster:Rod Buster` },
  { code: 'RodRoomAttendant', localizedLabel: $localize`:@@TRADE_TYPES.RodRoomAttendant:Rod room attendant` },
  { code: 'Scaffolding', localizedLabel: $localize`:@@TRADE_TYPES.Scaffolding:Scaffolding` },
  { code: 'SheetMetal', localizedLabel: $localize`:@@TRADE_TYPES.SheetMetal:Sheet metal` },
  { code: 'SprinklerFitter', localizedLabel: $localize`:@@TRADE_TYPES.SprinklerFitter:Sprinkler Fitter` },
  { code: 'Steamfitter', localizedLabel: $localize`:@@TRADE_TYPES.Steamfitter:Steamfitter` },
  { code: 'Surveyor', localizedLabel: $localize`:@@TRADE_TYPES.Surveyor:Surveyor` },
  { code: 'Technician', localizedLabel: $localize`:@@TRADE_TYPES.Technician:Technician` },
  { code: 'ToolRoomAttendant', localizedLabel: $localize`:@@TRADE_TYPES.ToolRoomAttendant:Tool room attendant` },
  { code: 'TruckDriver', localizedLabel: $localize`:@@TRADE_TYPES.TruckDriver:Truck driver` },
  {
    code: 'TruckBusDriver_WithCDL',
    localizedLabel: $localize`:@@TRADE_TYPES.TruckBusDriver_WithCDL:Truck/bus driver (with CDL)`,
  },
  { code: 'UtilityCraftsman', localizedLabel: $localize`:@@TRADE_TYPES.UtilityCraftsman:Utility Craftsman` },
  { code: 'Warehouseman', localizedLabel: $localize`:@@TRADE_TYPES.Warehouseman:Warehouseman` },
  {
    code: 'Welder',
    localizedLabel: $localize`:@@TRADE_TYPES.Welder:Welder`,
    subCraftTypes: [
      {
        code: 'CarbonStick',
        localizedLabel: $localize`:@@SUB_TRADE_TYPES.Welder.CarbonStick:Carbon stick (6010 or 7018)`,
      },
      { code: 'CarbonTIG', localizedLabel: $localize`:@@SUB_TRADE_TYPES.Welder.CarbonTIG:Carbon TIG` },
      { code: 'Chrome', localizedLabel: $localize`:@@SUB_TRADE_TYPES.Welder.Chrome:Chrome` },
      { code: 'ExoticAlloys', localizedLabel: $localize`:@@SUB_TRADE_TYPES.Welder.ExoticAlloys:Exotic alloys` },
      { code: 'FluxCore', localizedLabel: $localize`:@@SUB_TRADE_TYPES.Welder.FluxCore:Flux Core` },
      { code: 'Rig', localizedLabel: $localize`:@@SUB_TRADE_TYPES.Welder.Rig:Rig` },
      { code: 'Shop', localizedLabel: $localize`:@@SUB_TRADE_TYPES.Welder.Shop:Shop` },
      { code: 'Stainless', localizedLabel: $localize`:@@SUB_TRADE_TYPES.Welder.Stainless:Stainless` },
      { code: 'Stick', localizedLabel: $localize`:@@SUB_TRADE_TYPES.Welder.Stick:Stick` },
    ],
  },
  { code: 'WeldersHelper', localizedLabel: $localize`:@@TRADE_TYPES.WeldersHelper:Welders Helper` },
];
export const TRADE_TYPES_MAP = new Map<string, (typeof TRADE_TYPES)[number]>(
  TRADE_TYPES.map((tradeType) => [tradeType.code, tradeType])
);

export type ReferralType = LocalizedCode & {
  subReferralTypes?: LocalizedCode[];
};
export const REFERRAL_TYPES: ReferralType[] = [
  {
    code: 'Advertisement',
    localizedLabel: $localize`:@@REFERRAL_TYPES.Advertisement:Advertisement`,
    subReferralTypes: [
      { code: 'Billboard', localizedLabel: $localize`:@@REFERRAL_TYPES.Advertisement.Billboard:Billboard` },
      {
        code: 'GenericPclAdvertisement',
        localizedLabel: $localize`:@@REFERRAL_TYPES.Advertisement.GenericPclAdvertisement:Generic PCL advertisement`,
      },
      { code: 'Newspaper', localizedLabel: $localize`:@@REFERRAL_TYPES.Advertisement.Newspaper:Newspaper` },
      {
        code: 'OtherAdvertisement',
        localizedLabel: $localize`:@@REFERRAL_TYPES.Advertisement.OtherAdvertisement:Other advertisement`,
      },
    ],
  },
  { code: 'Agency', localizedLabel: $localize`:@@REFERRAL_TYPES.Agency:Agency` },
  { code: 'CareerFair', localizedLabel: $localize`:@@REFERRAL_TYPES.CareerFair:Career fair` },
  { code: 'CurrentPclEmployee', localizedLabel: $localize`:@@REFERRAL_TYPES.CurrentPclEmployee:Current PCL employee` },
  { code: 'DirectByPclDistrict', localizedLabel: $localize`:@@REFERRAL_TYPES.DirectByPclDistrict:PCL Office` },
  { code: 'FormerPclEmployee', localizedLabel: $localize`:@@REFERRAL_TYPES.FormerPclEmployee:Former PCL employee` },
  { code: 'FriendsFamilyNonPCL', localizedLabel: $localize`:@@REFERRAL_TYPES.FriendsFamilyNonPCL:Friends/Family` },
  {
    code: 'InternetSearchOrJobBoard',
    localizedLabel: $localize`:@@REFERRAL_TYPES.InternetSearchOrJobBoard:Internet search or job board`,
    subReferralTypes: [
      {
        code: 'CareerBuilderDotCom',
        localizedLabel: $localize`:@@REFERRAL_TYPES.InternetSearchOrJobBoard.CareerBuilderDotCom:CareerBuilder.com`,
      },
      {
        code: 'Craigslist',
        localizedLabel: $localize`:@@REFERRAL_TYPES.InternetSearchOrJobBoard.Craigslist:Craigslist`,
      },
      { code: 'Eluta', localizedLabel: $localize`:@@REFERRAL_TYPES.InternetSearchOrJobBoard.Eluta:Eluta` },
      {
        code: 'GovernmentJobBoard',
        localizedLabel: $localize`:@@REFERRAL_TYPES.InternetSearchOrJobBoard.GovernmentJobBoard:Government job board`,
      },
      { code: 'Indeed', localizedLabel: $localize`:@@REFERRAL_TYPES.InternetSearchOrJobBoard.Indeed:Indeed.com` },
      { code: 'Kijiji', localizedLabel: $localize`:@@REFERRAL_TYPES.InternetSearchOrJobBoard.Kijiji:Kijiji.com` },
      { code: 'Monster', localizedLabel: $localize`:@@REFERRAL_TYPES.InternetSearchOrJobBoard.Monster:Monster.com` },
      { code: 'Other', localizedLabel: $localize`:@@REFERRAL_TYPES.InternetSearchOrJobBoard.Other:Other` },
      {
        code: 'RoadtechsDotCom',
        localizedLabel: $localize`:@@REFERRAL_TYPES.InternetSearchOrJobBoard.RoadtechsDotCom:RoadTechs.com`,
      },
      {
        code: 'WorkopolisDotCom',
        localizedLabel: $localize`:@@REFERRAL_TYPES.InternetSearchOrJobBoard.WorkopolisDotCom:Workopolis.com`,
      },
      { code: 'Wowjobs', localizedLabel: $localize`:@@REFERRAL_TYPES.InternetSearchOrJobBoard.Wowjobs:Wowjobs.com` },
    ],
  },
  {
    code: 'MagazinesAndTradePublications',
    localizedLabel: $localize`:@@REFERRAL_TYPES.MagazinesAndTradePublications:Magazines/trade publications`,
  },
  { code: 'Other', localizedLabel: $localize`:@@REFERRAL_TYPES.Other:Other` },
  { code: 'PclReputation', localizedLabel: $localize`:@@REFERRAL_TYPES.PclReputation:Reputation of PCL` },
  { code: 'PclSignage', localizedLabel: $localize`:@@REFERRAL_TYPES.PclSignage:Signage` },
  { code: 'PclWebSite', localizedLabel: $localize`:@@REFERRAL_TYPES.PclWebSite:PCL.com` },
  {
    code: 'ProfessionalAffiliations',
    localizedLabel: $localize`:@@REFERRAL_TYPES.ProfessionalAffiliations:Professional affiliations`,
  },
  {
    code: 'SocialNetworks',
    localizedLabel: $localize`:@@REFERRAL_TYPES.SocialNetworks:Social networks`,
    subReferralTypes: [
      { code: 'Facebook', localizedLabel: $localize`:@@REFERRAL_TYPES.SocialNetworks.Facebook:Facebook` },
      { code: 'LinkedIn', localizedLabel: $localize`:@@REFERRAL_TYPES.SocialNetworks.LinkedIn:Linked In` },
      { code: 'Twitter', localizedLabel: $localize`:@@REFERRAL_TYPES.SocialNetworks.Twitter:Twitter` },
      { code: 'YouTube', localizedLabel: $localize`:@@REFERRAL_TYPES.SocialNetworks.YouTube:YouTube` },
    ],
  },
  {
    code: 'UniversityOrCollege',
    localizedLabel: $localize`:@@REFERRAL_TYPES.UniversityOrCollege:University or college`,
  },
];

export const SELF_IDENTIFICATION_GENDERS: LocalizedCode[] = [
  { code: GenderSelfIdentification.Female, localizedLabel: 'Female' },
  { code: GenderSelfIdentification.Male, localizedLabel: 'Male' },
  { code: GenderSelfIdentification.Unknown, localizedLabel: 'Unknown' },
  { code: GenderSelfIdentification.Undeclared, localizedLabel: 'Undeclared' },
  { code: GenderSelfIdentification.Other, localizedLabel: 'Other' },
];

export const SELF_IDENTIFICATION_RACES: LocalizedCode[] = [
  { code: RaceSelfIdentification.White, localizedLabel: 'White (not Hispanic or Latino)' },
  { code: RaceSelfIdentification.Black, localizedLabel: 'Black or African American (not Hispanic or Latino)' },
  { code: RaceSelfIdentification.Hispanic, localizedLabel: 'Hispanic or Latino' },
  { code: RaceSelfIdentification.Asian, localizedLabel: 'Asian (not Hispanic or Latino)' },
  {
    code: RaceSelfIdentification.AmericanIndian,
    localizedLabel: 'American Indian/Alaska Native (not Hispanic or Latino)',
  },
  {
    code: RaceSelfIdentification.PacificIslander,
    localizedLabel: 'Native Hawaiian or Pacific Islander (not Hispanic or Latino)',
  },
  { code: RaceSelfIdentification.TwoOrMore, localizedLabel: 'Two or more races (not Hispanic or Latino)' },
  { code: RaceSelfIdentification.IChooseNotToRespond, localizedLabel: 'I choose not to self-identify' },
];

export const SELF_IDENTIFICATION_CA_RACES: LocalizedCode[] = [
  { code: RaceSelfIdentificationCA.BlackCa, localizedLabel: 'Black (e.g., African, North American, Caribbean, etc.)' },
  { code: RaceSelfIdentificationCA.EastAsianCa, localizedLabel: 'East Asian (e.g., Chinese, Japanese, Korean, etc.)' },
  {
    code: RaceSelfIdentificationCA.LatinAmericanCa,
    localizedLabel: 'Latin American (e.g., Indigenous and non‑Indigenous persons from Central and South America, etc.)',
  },
  {
    code: RaceSelfIdentificationCA.SouthAsianCa,
    localizedLabel:
      'South Asian or East Indian (e.g., Indian, Pakistani, Bangladeshi, or East Indian from Guyana, Trinidad or East Africa, etc.)',
  },
  {
    code: RaceSelfIdentificationCA.SoutheastAsianCa,
    localizedLabel: 'Southeast Asian (e.g., Burmese, Cambodian, Filipino, Laotian, Thai, Vietnamese, Indonesian, etc.)',
  },
  {
    code: RaceSelfIdentificationCA.WestAsianCa,
    localizedLabel: 'West Asian, North African or Arab (e.g., Iranian, Lebanese, Egyptian, Syrian, etc.)',
  },
  {
    code: RaceSelfIdentificationCA.NotAMemberOfAVisibleMinorityCa,
    localizedLabel: 'Not a member of a visible minority',
  },
  { code: RaceSelfIdentificationCA.OtherCa, localizedLabel: 'Other' },
  {
    code: RaceSelfIdentificationCA.IdoNotWishToProvideThisInformationCa,
    localizedLabel: 'I do not wish to provide this information',
  },
];

export const SELF_IDENTIFICATION_CA_INDIGENOUS_IDENTITIES: LocalizedCode[] = [
  { code: IndigenousIdSelfIdentification.FirstNations, localizedLabel: 'First Nations' },
  { code: IndigenousIdSelfIdentification.Inuit, localizedLabel: 'Inuit' },
  { code: IndigenousIdSelfIdentification.Metis, localizedLabel: 'Métis' },

  { code: IndigenousIdSelfIdentification.NotAIndigenous, localizedLabel: 'Not an Indigenous person' },
  { code: IndigenousIdSelfIdentification.Other, localizedLabel: 'Other' },
  {
    code: IndigenousIdSelfIdentification.IChooseNotToRespond,
    localizedLabel: 'I choose not to respond to this question',
  },
];

export const SELF_IDENTIFICATION_CA_DISABILITY_STATUSES: LocalizedCode[] = [
  { code: DisabilitySelfIdentificationCA.Yes, localizedLabel: 'Yes' },
  { code: DisabilitySelfIdentificationCA.No, localizedLabel: 'No' },
  {
    code: DisabilitySelfIdentificationCA.IChooseNotToRespondToThisQuestion,
    localizedLabel: 'I choose not to respond to this question',
  },
];

export const SELF_IDENTIFICATION_PROTECTED_VETERAN_STATUSES: LocalizedCode[] = [
  {
    code: ProtectedVeteranSelfIdentification.IIdentifyAsAProtectedVeteran,
    localizedLabel: 'I identify as one or more of the classifications of protected veteran listed above',
  },
  {
    code: ProtectedVeteranSelfIdentification.IamNotAProtectedVeteran,
    localizedLabel: 'I am not a protected veteran',
  },
  {
    code: ProtectedVeteranSelfIdentification.IChooseNotToRespond,
    localizedLabel: 'I choose not to respond',
  },
];

export const SELF_IDENTIFICATION_DISABILITY_STATUSES: LocalizedCode[] = [
  {
    code: DisabilitySelfIdentification.YesIHaveADisability,
    localizedLabel: 'Yes, I have a disability, or have had one in the past',
  },
  {
    code: DisabilitySelfIdentification.NoIDontHaveADisability,
    localizedLabel: 'No, I do not have a disability and have not had one in the past',
  },
  {
    code: DisabilitySelfIdentification.IChooseNotToRespond,
    localizedLabel: 'I do not want to answer',
  },
];

/** Format \@#\@ #\@# */
export const REGEX_CA_POSTAL_CODE = '^([ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJKLMNPRSTVWXYZ]) ?(\\d[ABCEGHJKLMNPRSTVWXYZ]\\d)$';

/** Format ##### */
export const REGEX_US_ZIP_CODE = '^\\d{5}(-\\d{4})?$';

export const REGEX_EMAIL =
  /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)+$/;

export enum ApplicationStatus {
  Draft = 'Draft',
  Submitted = 'Submitted',
  Withdrawn = 'Withdrawn',
  Deleted = 'Deleted',
}

export enum EvaluationStatus {
  Pending = 'Pending',
  InProgress = 'In Progress',
  Completed = 'Completed',
}
